var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLawwd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110.896,
    height: 15.567,
    viewBox: "0 0 110.896 15.567",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "LAWWD_Logo",
    "data-name": "LAWWD Logo",
    d: "M0-30.6H16.082v-4.186H6.308V-46.164H0Zm29.435-5.581h-3.8l1.879-5.276h.045ZM16.865-30.6h6.71l.671-1.788h6.576l.671,1.788H38.2L31.4-46.164H23.664Zm24.4,0h6.2l2.192-8.634H49.7L51.87-30.6h6.2L62.74-46.164H56.634l-2.058,9.506h-.045l-2.326-9.506H47.172l-2.349,9.506h-.045l-2.058-9.506H36.615Zm26.08,0h6.2l2.192-8.634h.045L77.95-30.6h6.2L88.82-46.164H82.714l-2.058,9.506h-.045l-2.326-9.506H73.252L70.9-36.658h-.045L68.8-46.164H62.695Zm29.3-11.642h3.624c2.885,0,4.048,1.4,4.048,3.859s-1.163,3.859-4.048,3.859H96.648ZM90.34-30.6h12.414c5.3,0,8.141-2.311,8.141-7.783,0-5.734-2.863-7.783-8.276-7.783H90.34Z",
    transform: "translate(0 46.164)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLawwd);
export default __webpack_public_path__ + "static/media/LAWWD.02794e132a556479afaa54dce738a73a.svg";
export { ForwardRef as ReactComponent };